import React from 'react';
import { st, classes } from './Pagination.st.css';
import type { PaginationProps } from '../Carousel.types';

function _withDotClass(comp: React.ReactElement): React.ReactElement {
  const { className: existingClassName } = comp.props;
  // Merge the dot class with the existing className (which includes active state)
  const mergedClassName = existingClassName
    ? `${st(classes.dot)} ${existingClassName}`
    : st(classes.dot);

  return React.cloneElement(comp, { className: mergedClassName });
}

function Pagination({
  className,
  originalClassName,
  pages,
}: PaginationProps): React.ReactElement {
  return (
    <div className={st(classes.root, className, originalClassName)}>
      {pages.map(page => _withDotClass(page))}
    </div>
  );
}

Pagination.displayName = 'Pagination';

export { Pagination };
